// extracted by mini-css-extract-plugin
export default {"product__item":"MyOrderProduct_product__item__ARTxc","product__title":"MyOrderProduct_product__title__dvssT","product__img":"MyOrderProduct_product__img__xKvsO"};